import React, { useEffect, useState } from "react";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import { useDispatch } from "react-redux";
import { SET_NAVBAR_TITLE } from "action_creators/actioncreator";
import Chatbot from "views/Components/chatbot/Chatbot";
import ProductContent from "views/ProductContent/ProductContent";
import { Redirect } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: "50px",
  },
}));

const Contentmanagement = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const profileData = JSON.parse(localStorage.getItem("profileData"));
  const account = profileData.account;

  let domain = JSON.parse(localStorage.getItem("internal_domains"))?.domains;
  let userEmail = JSON.parse(localStorage.getItem("profileData"))?.email;
  let hasDomain = domain?.some((res) => userEmail.includes(res));

  const [isInternal] = useState(hasDomain);

  useEffect(() => {
    dispatch(
      SET_NAVBAR_TITLE(
        isInternal ? account + "  - Content Management" : "Content Management"
      )
    );
  }, [dispatch, isInternal, account]);
    const content_management = sessionStorage.getItem("enabled_roles")
  ? JSON.parse(sessionStorage.getItem("enabled_roles")).includes("Content Management")
    ? true
    : false
  : false;

  if (content_management) {
    return (
      <div>
        <Grid container className={classes.root}>
          <Grid item xs={12}>
            <ProductContent />
          </Grid>
        </Grid>
        <Chatbot />
      </div>
    );
  } else {
    return <Redirect to="/dashboard" />;
  }
};

export default Contentmanagement;
